<div class="dialog-header">
    <h2 mat-dialog-title>Purchase Price Allocation</h2>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content [formGroup]="deferralForm">
    <div>Payment structure:
        <mat-radio-group [formControl]="deferralForm.controls.includeDeferrals"
                         (change)="onIncludeDeferralsChange($event.value)">
            <mat-radio-button [value]="false" color="primary">Single payment at closing</mat-radio-button>
            <mat-radio-button [value]="true" color="primary">Deferred payment schedule</mat-radio-button>
        </mat-radio-group>
    </div>
    @if (deferralForm.controls.includeDeferrals.value) {
        <div>
            <div formArrayName="deferrals" class="deferrals-list">
                @for (row of deferralsFA.controls; track row; let i = $index) {
                    <div [formGroupName]="i" class="deferral-row">
                        <mat-form-field appearance="outline">
                            <mat-label>Due Date</mat-label>
                            <input matInput
                                   formControlName="dueDate"
                                   id="cashflowDate"
                                   [matDatepicker]="deferralDatePicker">
                            <mat-hint>dd/MM/yyyy</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="deferralDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #deferralDatePicker></mat-datepicker>
                            @if (row.get('dueDate')?.hasError('dateBefore')) {
                                <mat-error>Date must not be before the closing date.</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>%</mat-label>
                            <input matInput type="number" min="0" max="100" step="0.01" formControlName="percentage"
                                   (input)="clearOther(i, 'percentage')"/>
                        </mat-form-field>
                        <button mat-icon-button color="primary" type="button" (click)="remove(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>

                }
            </div>

            <div class="deferrals-actions">
                <button mat-stroked-button type="button" (click)="add()">Add deferral</button>
                <button mat-stroked-button type="button" (click)="reset()">Reset</button>
                @if (deferralsFA.hasError('totalNotOne')) {
                    <mat-error>
                        Total must be 100%
                    </mat-error>
                }
            </div>

        </div>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button color="primary"
            [disabled]="isSaveDisable()"
            (click)="save()">
        Save
    </button>
</mat-dialog-actions>

